import React from 'react';

export const ContactPage = () => {
  return (
    <section>
      <h1 className="page-title">Contact</h1>
      <p className="contact-intro">
        ご質問やご案件のご相談は、下記フォームからお気軽にお問い合わせください。
      </p>
      <div className="contact-form-container">
        <iframe
          src="https://docs.google.com/forms/d/e/1FAIpQLSf3pCiH3L7oQ6TYrJxADj6iN5fWqd6fCjtepVOAwNiB8nb3nA/viewform?embedded=true"
          width="100%"
          height="1300"
          frameBorder="0"
          marginHeight={0}
          marginWidth={0}
          title="Contact Form"
        >
          読み込んでいます…
        </iframe>
      </div>
    </section>
  );
};
